import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields/';

const get_list = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/lw_api_settings/list`),
    params,
  });
};
const get_list_options = (fieldId, params) => {
  return {
    method: 'GET',
    url: path.concat(`${fieldId}/lw_api_settings/list`),
    params,
  }
}

// LINE WORKS API設定一覧取得API
const list = {
  get: get_list,
  get_options: get_list_options
}

// LINE WORKS API設定詳細取得API
const show = (fieldId, id, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`${fieldId}/lw_api_settings/${id}`),
    params,
  });
};

// LINE WORKS API設定新規作成API
const create = (fieldId, params) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`${fieldId}/lw_api_settings`),
    params,
  });
};

// LINE WORKS API設定更新API
const update = (fieldId, id, params) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`${fieldId}/lw_api_settings/${id}`),
    params,
  });
};

// LINE WORKS API設定削除API
const del = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`${fieldId}/lw_api_settings/${id}`),
  });
};

export const LwApiSettings = {
  list,
  show,
  create,
  update,
  del,
};
export default LwApiSettings;



// WEBPACK FOOTER //
// ./src/services/LwApiSettings.js